import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-product-management.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  ProductDefaultSortColumnOrder,
  ProductFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IProductFilter } from '../../models/IProductFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  CopyIcon,
  DeleteIcon,
  EditIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditProductManagement from './components/add-edit-product-mgmt';
import FilterComponent from './components/filter';
import AddProductPopupHOC from './hoc/add-product-mgmt-popup-hoc';
import CopyProductPopupHOC from './hoc/copy-product-popup-hoc';
import ProductManagementDetails from './product-mgmt-details';
import './product-mgmt.css';
import { Search } from 'react-bootstrap-icons';
import CopyProduct from './components/copy-product';

const ProductManagement = (props: any) => {
  const { productStore, preferencesStore, processTemplateStore } = useStore();

  const {
    GetProductListService,
    allProduct,
    productList,
    deleteProductState,
    DeleteProductService,
    resetDeleteProduct,
    resetProductDetail,
    addUpdateProductState,
    resetAddUpdateProductState,
    productState,
    getAllProductState,
    copyProductState,
    resetCopyProductState,
    GetProductByIdService,
    ValidateProductNameState,
    ValidateProductNameService,
    isProductNameValid,
    resetValidateProductNameState,
    allProductReactSelectOptions,
    GetAllProductService,
    productId,
    setProductId,
    getproductId,
    ExportProductReportService,
    exportProductReportState,
    resetExportProductReportState,
    base64String,
  } = productStore;
  const { resetProcessTemplateDetail } = processTemplateStore;
  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  let lang: string;
  const allProductListData = allProduct;
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    ProductDefaultSortColumnOrder
  );
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [filterObj, setFilterObj] = useState<IProductFilter>(
    ProductFilterInitialState
  );

  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [showOptions, setShowOptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isProductIdApplied, setIsProductIdApplied] = useState(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProductListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetProductListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    } else {
      GetProductListService(
        1,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    if (isProductNameValid) {
      toast.error(formatMessage('AlreadyExists'));
    }
  }, [isProductNameValid]);

  useEffect(() => {
    getProductListServiceHandler(createQueryString(filterObj), true);
  }, [filterObj]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: productList?.PagingDetails?.CurrentPage,
      totalPages: productList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [productList]);

  useEffect(() => {
    if (!isProductIdApplied || !getproductId) return;

    const matchingProduct =
      allProductListData.find(
        (product: any) => product.ProductName === getproductId
      ) || (allProductListData.length === 1 ? allProductListData[0] : undefined);

    if (matchingProduct) {
      setSelectedRow((previousRow: any) =>
        previousRow?.Id === matchingProduct.Id ? previousRow : matchingProduct
      );
      // setOpenPanel(true);
    } else {
      setSelectedRow({});
      setOpenPanel(false);
      resetProductDetail();
    }
  }, [productList, isProductIdApplied, getproductId]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProductListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (language !== lang) {
      getProductListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (copyProductState.success) {
      const newProductId = productStore.newCopiedProductId;
      resetCopyProductState();
      getProductListServiceHandler();
      if (newProductId && newProductId > 0) {
        openAddProductHandler({ Id: newProductId }, undefined, true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyProductState.success]);

  useEffect(() => {
    if (addUpdateProductState.success) {
      resetAddUpdateProductState();
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateProductState.success]);

  useEffect(() => {
    if (deleteProductState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteProduct();
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProductState.success]);

  useEffect(() => {
    setProductId('');
    GetAllProductService(Number(getTenantIdFromLocalStorage()));
  }, []);

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const now = new Date();
    const japanDate = new Date(
      now.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
    );

    const jpString =
      japanDate.getFullYear().toString() +
      String(japanDate.getMonth() + 1).padStart(2, '0') +
      String(japanDate.getDate()).padStart(2, '0') +
      String(japanDate.getHours()).padStart(2, '0') +
      String(japanDate.getMinutes()).padStart(2, '0') +
      String(japanDate.getSeconds()).padStart(2, '0');
    link.download = `ProductReportFile-${jpString}.csv`;
    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    closePanelHandler();
    // resetFactoryScheduleDetail();
  };

  useEffect(() => {
    if (exportProductReportState.success) {
      handleExport(base64String.fileString);
      resetExportProductReportState();
    }
  }, [exportProductReportState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const applyProductIdFilter = () => {
    const productIdValue = getproductId.trim();

    if (!productIdValue) {
      clearProductIdFilter();
      return;
    }

    setSelectedRow({});
    setOpenPanel(false);
    resetProductDetail();
    setFilterObj((previousFilter) => ({
      ...previousFilter,
      ProductId: productIdValue,
    }));
    setIsProductIdApplied(true);
  };

  const clearProductIdFilter = () => {
    setIsProductIdApplied(false);
    setFilterObj((previousFilter) => ({
      ...previousFilter,
      ProductId: '',
    }));
    setProductId('');
    setSelectedRow({});
    setOpenPanel(false);
    resetProductDetail();
  };

  const refreshClickHandler = () => {
    getProductListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteProductService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProductDetail();
    props.deletePopupToggleHandler();
  };

  const copyClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProductDetail();
    // GetProductByIdService(Number(getTenantIdFromLocalStorage()), row.Id, true);
    // openAddProductHandler({ Id: -1 }, event, false);
    props.copyToggleHandler();
  };

  const openAddProductHandler = (
    row: { Id: number },
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    isReset: boolean = true
  ) => {
    localStorage.setItem('images', JSON.stringify([]));
    if (event) event.stopPropagation();
    closePanelHandler();
    if (isReset) resetProductDetail();
    // resetProductDetail();
    setSelectedId(row.Id);
    props.addToggleHandler(true);
    resetProcessTemplateDetail();
  };

  const createQueryString = (filter: IProductFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IProductFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getProductListServiceHandler(filter, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelHandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: IProductFilter, isFilterCleared: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isFilterCleared) {
      setFilterObj({ ...obj });
      getProductListServiceHandler(filter);
      closePanelHandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const exportFileHandler = () => {
    const filters = createQueryString({ ...filterObj });
    ExportProductReportService(
      Number(getTenantIdFromLocalStorage()),
      encodeURIComponent(filters)
    );
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProductHandler,
        icon: <EditIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
      {
        dataField: 'isCopy',
        handler: copyClickHandler,
        icon: <CopyIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Copy'
        ),
        title: 'copy',
        varient: 'success',
        action: 'copy',
      },
    ],
    ModuleType.ProductManagement
  );

  const columns: any = [
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      hidden: false,
    },

    {
      dataField: 'Katashiki',
      text: formatMessage('katashiki'),
      classes: 'show-Elipses',
      hidden: false,
    },
    {
      dataField: 'Customer',
      text: formatMessage('customer'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'TraySize',
      text: formatMessage('tray_size'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Remarks',
      text: formatMessage('comment'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <>
      {props.showAddProductPopup && (
        <AddEditProductManagement
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showCopyProductPopup && (
        <CopyProduct
          id={selectedId}
          modalClosed={props.copyToggleHandler}
        />
      )}

      {props.showDeletePopup && (
        <DeletePopup
          title="delete_product"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_product_confirm"
          isLoading={deleteProductState.inProgress}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-5 col-md-6 col-sm-6"
            label="product_title"
          />
          <div className="col-lg-7 col-md-6 col-sm-6">
            <ul className="add-list">
              <li className="d-flex">
                <div className="mx-2 search-id-prod">
                  <div
                    className=""
                    style={{
                      position: 'relative',
                    }}
                  >
                    <input
                      className="form-control"
                      type="text"
                      value={getproductId}
                      placeholder={formatMessage('product_id')}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // remove non-numeric characters
                        setProductId(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          applyProductIdFilter();
                        }
                      }}
                    />{' '}
                    <button
                      type="button"
                      onClick={() => {
                        applyProductIdFilter();
                      }}
                      className={`btn btn-sm ${isProductIdApplied ? 'remove-btn-product-search' : 'remove-btn-product-search-fix '}`}
                    >
                      <Search />
                    </button>
                    {isProductIdApplied && (
                      <button
                        type="button"
                        onClick={() => {
                          clearProductIdFilter();
                        }}
                        className="btn btn-danger btn-sm remove-btn-product"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                </div>
                {/* <div className="">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      productId &&
                        setFilterObj(() => ({
                          ...filterObj,
                          ProductId: productId,
                        }));
                      setIsFilterApplied(true);
                    }}
                  >
                    {formatMessage('search')}
                  </button>
                </div> */}
              </li>
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                  setSearchTerm={setSearchTerm}
                />
              </li>
              <li title={formatMessage('factory_schedule_export')}>
                <a
                  data-toggle="modal"
                  className={`btn btn-light`}
                  onClick={() => exportFileHandler()}
                >
                  <svg
                    version="1.1"
                    id="Capa_1"
                    fill="currentColor"
                    width="20"
                    height="20"
                    x="0px"
                    y="0px"
                    viewBox="0 0 405.2 512"
                  >
                    <g>
                      <path
                        d="M185.9,165.8l-40,40c-7.8,7.8-7.8,20.5,0,28.3s20.5,7.8,28.3,0l5.9-5.9V300c0,11,9,20,20,20s20-9,20-20v-71.7l5.9,5.9
                  c7.8,7.8,20.5,7.8,28.3,0c7.8-7.8,7.8-20.5,0-28.3l-40-40C206.4,158,193.6,158.1,185.9,165.8L185.9,165.8z"
                      />
                      <path
                        d="M394.1,125.8l-120-120C273.9,5.7,268.7,0,260,0H60C26.9,0,0,26.9,0,60v392c0,33.1,26.9,60,60,60h40c11,0,20-9,20-20
                  s-9-20-20-20H60c-11,0-20-9-20-20V60c0-11,9-20,20-20h180v60c0,33.1,26.9,60,60,60h60v140c0,11,9,20,20,20s20-9,20-20V140
                  C400,134.7,397.9,129.6,394.1,125.8L394.1,125.8z M300,120c-11,0-20-9-20-20V68.3l51.7,51.7H300z"
                      />
                    </g>
                    <g>
                      <path
                        d="M156.2,449.4c0,22.5,9.4,33.7,28.3,33.7c3.4,0,6.6-0.3,9.6-1s6.7-1.7,11-3.2c3.5,7.6,5.8,15.5,7,23.5
                  c-3.1,1.2-5.9,2.1-8.6,2.9c-2.6,0.7-5.2,1.3-7.6,1.7c-2.4,0.4-4.8,0.6-7.2,0.8c-2.4,0.2-4.8,0.2-7.4,0.2c-9,0-16.9-1.5-23.8-4.4
                  c-6.8-2.9-12.6-7-17.2-12.2c-4.6-5.2-8.1-11.4-10.4-18.6c-2.3-7.2-3.5-15-3.5-23.5c0-8.5,1.2-16.3,3.7-23.6
                  c2.4-7.3,6-13.5,10.6-18.8c4.6-5.3,10.3-9.4,17.1-12.4c6.8-3,14.5-4.4,23-4.4c5.1,0,9.9,0.4,14.5,1.1c4.6,0.7,9.6,2.2,15.3,4.4
                  c-0.2,4.3-1,8.6-2.4,12.6c-1.4,4.1-2.8,7.7-4.3,10.7c-2.1-0.7-4.1-1.4-5.8-1.9c-1.7-0.5-3.4-1-5-1.3s-3.2-0.6-4.8-0.7
                  s-3.3-0.2-5.1-0.2c-8.6,0-15.2,2.9-19.9,8.7C158.6,429.4,156.2,438,156.2,449.4z"
                      />
                      <path
                        d="M270.8,436.5c4.4,1.8,8.4,3.6,12,5.5c3.5,1.9,6.6,4.1,9.1,6.7c2.5,2.6,4.5,5.7,5.9,9.4c1.4,3.7,2.1,8.1,2.1,13.3
                  c0,5.6-1,10.7-2.9,15.2c-2,4.5-4.8,8.4-8.7,11.6c-3.8,3.2-8.5,5.7-14.1,7.5c-5.6,1.7-11.9,2.6-19.1,2.6c-6.6,0-12.4-0.5-17.4-1.6
                  c-5-1.1-10.5-2.7-16.3-4.9c0.4-3.7,1.2-7.7,2.2-11.8c1.1-4.2,2.3-8.4,3.8-12.8c9.7,4.2,18.2,6.4,25.4,6.4c5.4,0,9.6-0.8,12.6-2.5
                  c3-1.6,4.5-4.5,4.5-8.5c0-1.7-0.3-3.2-1-4.4c-0.6-1.2-1.5-2.2-2.5-3.1c-1.1-0.8-2.3-1.6-3.6-2.1c-1.3-0.6-2.7-1.1-4.1-1.7l-8.9-3.3
                  c-3.8-1.4-7.3-3-10.4-4.9c-3.1-1.9-5.8-4.2-8-6.8c-2.2-2.6-3.9-5.6-5.2-9c-1.2-3.4-1.8-7.4-1.8-11.9c0-5.6,1-10.6,2.9-14.9
                  c1.9-4.3,4.6-8,8-11c3.4-3,7.6-5.3,12.5-6.8c4.9-1.5,10.3-2.3,16.4-2.3c5.4,0,10.6,0.5,15.7,1.6c5,1.1,10.4,2.6,16.1,4.6
                  c-0.4,3.4-1.2,7.1-2.3,11.2c-1.1,4.1-2.5,7.9-4.2,11.5c-2.8-1.2-6-2.4-9.7-3.7c-3.7-1.3-8.3-1.9-13.8-1.9c-1.7,0-3.3,0.2-4.8,0.5
                  c-1.5,0.3-2.9,0.8-4.1,1.5c-1.2,0.7-2.2,1.6-2.9,2.9c-0.7,1.2-1.1,2.7-1.1,4.5c0,3.1,1,5.3,3,6.8c2,1.5,4.4,2.8,7.2,3.8
                  L270.8,436.5z"
                      />
                      <path
                        d="M354.5,469.3l21.8-76.9c2.4-0.4,4.9-0.7,7.4-1c2.5-0.2,5.1-0.3,7.9-0.3c1.8,0,4,0.1,6.7,0.4c2.6,0.3,5,0.6,7,0.9L368.7,506
                  c-2.8,0.4-5.3,0.7-7.7,1c-2.4,0.2-4.7,0.3-6.9,0.3c-2.1,0-4.3-0.1-6.5-0.3c-2.2-0.2-4.9-0.5-7.9-1l-36.4-113.6
                  c1.8-0.3,4.2-0.6,7.1-0.9c3-0.3,5.8-0.4,8.6-0.4c2.2,0,4.7,0.1,7.3,0.4c2.6,0.3,5,0.6,7,0.9L354.5,469.3z"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ProductManagement,
                'Add'
              ) && (
                  <li title={formatMessage('add_product')}>
                    <a
                      className="btn btn-secondary"
                      data-toggle="modal"
                      data-testid="modalbtn"
                      data-target="#addUser"
                      onClick={(event: any) =>
                        openAddProductHandler({ Id: -1 }, event)
                      }
                    >
                      <span className="me-1">
                        <PlusIcon />
                      </span>
                      <FormattedMessage id="add_product" />
                    </a>
                  </li>
                )}
            </ul>
          </div>
        </div>
      </div>

      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllProductState.inProgress ||
            productState.inProgress ||
            deleteProductState.inProgress ||
            copyProductState.inProgress) && (
              <FormLoader
                loading={
                  getAllProductState.inProgress ||
                  productState.inProgress ||
                  deleteProductState.inProgress ||
                  copyProductState.inProgress
                }
              />
            )}
          {allProductListData && allProductListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive tray-management-table"
                    data-testid="table"
                  >
                    {allProductListData && (
                      <Grid
                        data={allProductListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                      />
                    )}
                  </div>
                </div>
              </div>

              {allProductListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={productList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div className="col-lg-8 mt-5 p-3">
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_product" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_product_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.ProductManagement,
                    'Add'
                  ) && (
                      <>
                        <a
                          className="btn btn-primary"
                          onClick={(event: any) =>
                            openAddProductHandler({ Id: -1 }, event)
                          }
                        >
                          <span className="me-1">
                            <PlusIcon />
                          </span>
                          <FormattedMessage id="add_product" />
                        </a>
                      </>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.ProductName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <ProductManagementDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default CopyProductPopupHOC(
  FilterPopupHOC(
    AddProductPopupHOC(DeletePopupHOC(observer(ProductManagement)))
  )
);
